/* eslint-disable */
export default {
  ringtones: 'Ring tones',
  incomingRingtone: 'Incoming ring tone',
  outgoingRingtone: 'Outgoing ring tone',
  play: 'Play',
  stop: 'Stop',
  upload: 'Upload',
  reset: 'Reset',
  save: 'Save',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
